import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faClock, faUser } from '@fortawesome/free-solid-svg-icons';
import { ToggleButtonField } from '../common';

interface CardHeaderProps {
	icon: IconDefinition;
	title: string;
	isActive?: boolean;
	onToggle?: (value: boolean) => void;
	createdAt?: string;
	createdBy?: string;
	loading?: boolean;
}

const CardHeader: React.FC<CardHeaderProps> = ({
	icon,
	title,
	isActive,
	onToggle,
	createdAt,
	createdBy,
	loading,
}) => (
	<div className="flex items-start">
		<div className="flex items-center">
			<FontAwesomeIcon icon={icon} className="w-16 h-16 text-blue-900/90" />
			<div className="flex flex-col ml-4">
				<h1 className="text-3xl font-bold">{title}</h1>
				{onToggle !== undefined && isActive !== undefined && (
					<div className="mt-2">
						<ToggleButtonField
							label="Actif"
							isOn={isActive}
							onChange={onToggle}
							invert={true}
							size="sm"
							loading={loading}
						/>
					</div>
				)}
			</div>
		</div>

		{(createdAt || createdBy) && (
			<div className="ml-auto text-right text-sm text-gray-300 flex flex-col justify-start hover:text-gray-600 hover:cursor-default">
				{createdAt && !loading && (
					<div className="flex items-center justify-end gap-1">
						<FontAwesomeIcon icon={faClock} className="text-xs mr-1" />
						<span>{new Date(createdAt).toLocaleDateString()}</span>
					</div>
				)}
				{createdBy && !loading && (
					<div className="flex items-center justify-end gap-1">
						<FontAwesomeIcon icon={faUser} className="text-xs mr-1" />
						<span>{createdBy}</span>
					</div>
				)}
			</div>
		)}
	</div>
);

export default CardHeader;
